import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { ajax } from "@rails/ujs"

export default class extends Controller {
  static values = {
    url: String,
    handle: { type: String, default: ".grabbable" }
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      handle: this.handleValue,
      animation: 150,
      forceFallback: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      revertOnSpill: true,
      onEnd: this.reorder.bind(this)
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  reorder(event) {
    const id = event.item.dataset.id

    ajax({
      url: this.urlValue.replace(":id", id) + `?new_index=${event.newIndex}`,
      type: "PATCH"
    })
  }
}
